<div class="container">
  <label class="label">
    <span class="label-content">
      <span>{{ label() }}</span>
      <fb-scribe-suggestion-indicator
        [target]="markerTarget()"
        [fieldKey]="markerFieldKey()"
      ></fb-scribe-suggestion-indicator>
      <fb-amendment-field-indicator [rowIndex]="rowIndex()" [fieldKey]="markerFieldKey()" />
    </span>
  </label>
  <input
    type="text"
    [ngModel]="text()"
    (ngModelChange)="handleTextChange($event)"
    [ngModelOptions]="{ standalone: true }"
    [placeholder]="placeholder()"
    [maskito]="mask()"
    class="input"
  />
</div>
